import { Scene, AbstractMesh, Observable } from '@babylonjs/core';
import ObservablesManager from './ObservablesManager';
import { Report } from '../../interfaces';

export default class CollisionManager {
	private colliders: Map<AbstractMesh, Set<Report>>;
	public onBeforeRender = new Map<number, () => void>();

	constructor(private scene: Scene, private observablesManager: ObservablesManager) {
		this.colliders = new Map<AbstractMesh, Set<Report>>();
		this.scene.onBeforeRenderObservable.add(() => this.onBeforeRender.forEach((c) => c()));
	}

	/**
	 * Will notify when collision report has happend.
	 */
	public get onCollision(): Observable<[AbstractMesh, AbstractMesh[]]> {
		return this.observablesManager.onCollisionObservable;
	}

	/**
	 * Will notify when collision end report has happend.
	 */
	public get onCollisionEnd(): Observable<AbstractMesh> {
		return this.observablesManager.onCollisionEndObservable;
	}

	public registerCollider(mesh: AbstractMesh, reporter: Report): void {
		if (this.colliders.has(mesh)) {
			(this.colliders.get(mesh) as Set<Report>).add(reporter);
		} else {
			this.colliders.set(mesh, new Set<Report>([reporter]));
		}
	}

	public unregisterCollider(mesh: AbstractMesh, reporter: Report): void {
		if (this.colliders.has(mesh)) {
			const reporters = this.colliders.get(mesh);
			if (reporters) {
				reporters.delete(reporter);
				if (reporters.size === 0) {
					this.colliders.delete(mesh);
				}
			}
		}
	}

	public getCollisionReporters(mesh: AbstractMesh): Set<Report> {
		const collider = this.colliders.get(mesh);
		if (collider) {
			return collider;
		}

		throw 'CollisionManager: getCollisionReporters(): collider does not exist.';
	}

	public getCollisions(target: AbstractMesh): Map<AbstractMesh, Set<Report>> {
		const map = new Map<AbstractMesh, Set<Report>>();
		this.colliders.forEach((reporters, collider) => {
			if (target !== collider) {
				if (collider.intersectsMesh(target)) {
					const r = map.get(collider);
					if (r) {
						reporters.forEach((i) => r.add(i));
					} else {
						map.set(collider, new Set(reporters));
					}
				}
			}
		});

		return map;
	}
}
